import { HttpParams } from "@capacitor/core";
import { HttpMethods, sendRequest } from "../util/ApiHelper";

const CONTROLLER_NAME = "EquipmentMasters";

export const getEquipment = async (params: HttpParams) => {
  return await sendRequest(HttpMethods.GET, `${CONTROLLER_NAME}/Get`, undefined, params);
};

export const getEquipmentUdvList = async (equipment: string) => {
  return await sendRequest(HttpMethods.GET, `EquipmentUserValues/GetDataForEquipment`, undefined, {
    equipment,
    includeTranslation: "false",
  });
};

// US 869961 / Bug 873785: Traverse eq_hierarchy upward from the given equipment
// and return the first ancestor that has a Shop and/or Planner value.
export const getParentShopAndPlanner = async (params: { equipment: string }) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetParentShopAndPlanner`,
    undefined,
    params
  );
};
